/*
 * @Author: your name
 * @Date: 2020-11-06 10:48:51
 * @LastEditTime: 2021-01-11 17:33:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\assets\js\composite_question_type.js
 */
const typeNameMap = {
  1: "单选题",
  2: "现代文阅读",
  3: "文言文阅读",
  4: "诗歌鉴赏",
  5: "语言表达",
  6: "名著阅读",
  7: "默写",
  9: "作文",
  11: "填空题",
  12: "计算题",
  13: "解答题",
  16: "单词拼写",
  18: "翻译",
  19: "完形填空",
  20: "阅读理解",
  23: "选词填空",
  24: "书面表达",
  25: "实验题",
  28: "综合题",
  29: "不定项选择题",
  32: "推断题",
  39: "短文改错",
  40: "七选五",
  42: "语法填空",
  45: "双选题",
  54: "任务型阅读",
  103: "判断题",
  140: "听力选择",
  141: "听力填空",
  162: "句型转换",
  200: "单项填空",
  201: "材料概括分析题",
  202: "文学类文本阅读",
  203: "论述类文本阅读",
  204: "实用类文本阅读",
  205: "古代诗歌阅读",
  206: "古代诗文阅读",
  207: "语言文字运用",
  208: "多项选择题",
  209: "单词填空",
  210: "听力1",
  212: "读后续写",
  214: "听力2",
  215: "应用文写作",
  216: "古诗词鉴赏",
  217: "微写作",
  218: "文段阅读",
  219: "材料阅读",
  220: "压缩语段",
  221: "客观填空题",
  222: "主观填空题",
  223: "听力理解",
  224: "写作",
  225: "阅读表达",
  226: "概要写作",
  227: "简答题",
  228: "证明题",
  229: "作文选做",
  230: "作图题",
  231: "改写题",
  232: "标记题",
  233: "附加题",
  234: "选做题"
}
export default typeNameMap